// firebaseConfig.js
// Firebase configuration and initialization

import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAnalytics } from "firebase/analytics";

export const firebaseConfig = {
  apiKey: "AIzaSyCn61hEJUxxMtG9Vd7Lm1WLcWvXViY4UiA",
  authDomain: "kuwait-ophthalmic-society.firebaseapp.com",
  projectId: "kuwait-ophthalmic-society",
  storageBucket: "kuwait-ophthalmic-society.firebasestorage.app",
  messagingSenderId: "713646669330",
  appId: "1:713646669330:web:ad1cef9b78b8703410e2cb",
  measurementId: "G-VC1X1H0MN8"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const analytics = getAnalytics(app);

